/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/Partners.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const Partners: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18" ref={ref} {...props}>
    <path
      id="Partners-Icon"
      fill={color}
      d="M2.988 6.012h12.024q.315 0 .527.21.21.212.211.528v7.488q0 .105-.035.211l-.07.211a.6.6 0 0 1-.106.14 2 2 0 0 0-.176.106 1.4 1.4 0 0 1-.175.07.4.4 0 0 1-.176.036H2.988a.72.72 0 0 1-.527-.211.84.84 0 0 1-.211-.563V6.75q0-.316.21-.527.212-.211.528-.211m0-1.512q-.914 0-1.582.668-.668.633-.668 1.582v7.488q0 .95.668 1.582.669.669 1.582.668h12.024q.914 0 1.582-.668.668-.633.668-1.582V6.75q0-.95-.668-1.582-.669-.668-1.582-.668zm8.262 11.25q0 .21.105.387.106.176.282.246.176.105.351.105.316 0 .528-.21a.67.67 0 0 0 .246-.528V3.762q0-.95-.668-1.582-.669-.669-1.582-.668H7.488q-.914 0-1.582.668-.668.633-.668 1.582V15.75q0 .21.106.387.105.176.281.246.175.105.387.105.28 0 .492-.21a.67.67 0 0 0 .246-.528V3.762q0-.21.105-.387a.8.8 0 0 1 .282-.281.7.7 0 0 1 .351-.106h3.024q.28 0 .492.246.246.212.246.528z"
    />
  </svg>
);
Partners.displayName = "Partners";
